// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* ─── Bootstrap spacing shims (only classes still in legacy code) ── */
.mt-3 {
  margin-top: 1rem !important;
}

.mx-4 {
  margin-left: 1.5rem !important;
  margin-right: 1.5rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

/* ─── Design Tokens ─────────────────────────────────────────── */
:root {
  /* Palette */
  --clr-bg: #f1f5f9;
  --clr-surface: #ffffff;
  --clr-border: #e2e8f0;
  /* Sidebar */
  --clr-sidebar-bg: #0f172a;
  --clr-sidebar-item: rgba(255, 255, 255, 0.6);
  --clr-sidebar-hover: rgba(255, 255, 255, 0.08);
  --clr-sidebar-active-from: #6366f1;
  --clr-sidebar-active-to: #4f46e5;
  /* Brand / Accent */
  --clr-primary: #6366f1;
  --clr-primary-dark: #4f46e5;
  --clr-primary-light: rgba(99, 102, 241, 0.1);
  --clr-accent: #06b6d4;
  --clr-success: #10b981;
  --clr-warning: #f59e0b;
  --clr-danger: #ef4444;
  /* Text */
  --clr-text-primary: #0f172a;
  --clr-text-secondary: #64748b;
  --clr-text-muted: #94a3b8;
  /* Shadows */
  --shadow-xs: 0 1px 2px rgba(0, 0, 0, 0.05);
  --shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.07), 0 1px 2px rgba(0, 0, 0, 0.04);
  --shadow-md: 0 4px 12px rgba(0, 0, 0, 0.08), 0 2px 4px rgba(0, 0, 0, 0.04);
  --shadow-lg: 0 10px 30px rgba(0, 0, 0, 0.1), 0 4px 8px rgba(0, 0, 0, 0.04);
  --shadow-primary: 0 4px 14px rgba(99, 102, 241, 0.35);
  /* Dimensions */
  --sidebar-width: 256px;
  --sidebar-collapsed: 72px;
  --header-height: 64px;
  /* Radii */
  --radius-sm: 6px;
  --radius-md: 10px;
  --radius-lg: 14px;
  --radius-xl: 20px;
  /* Transitions */
  --transition-fast: 0.15s ease;
  --transition-base: 0.2s ease;
  --transition-slow: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  /* Typography */
  --font-sans:
    "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

/* ─── Base Reset ─────────────────────────────────────────────── */
*,
*::before,
*::after {
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: var(--font-sans);
  font-size: 14px;
  line-height: 1.6;
  color: var(--clr-text-primary);
  background-color: var(--clr-bg);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

/* ─── Ant Design Global Overrides ───────────────────────────── */
.ant-table-content {
  overflow-y: scroll;
}

/* Table header */
.ant-table-content th,
.ant-table-thead > tr > th {
  background-color: #f8fafc !important;
  color: var(--clr-text-secondary) !important;
  font-weight: 600 !important;
  font-size: 12px !important;
  text-transform: uppercase !important;
  letter-spacing: 0.05em !important;
  border-bottom: 1px solid var(--clr-border) !important;
}

.ant-table-wrapper {
  border-radius: var(--radius-lg) !important;
  overflow: hidden;
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--clr-border);
}

.ant-table {
  font-family: var(--font-sans) !important;
  font-size: 13px !important;
}

.ant-table-row:hover > td {
  background: #f8faff !important;
}

/* Ant Form */
.ant-form-item-label > label {
  font-weight: 500 !important;
  font-size: 13px !important;
  color: var(--clr-text-secondary) !important;
}

.ant-input,
.ant-input-affix-wrapper,
.ant-select-selector,
.ant-picker {
  border-radius: var(--radius-md) !important;
  border-color: var(--clr-border) !important;
  font-family: var(--font-sans) !important;
  font-size: 14px !important;
  transition: border-color var(--transition-base), box-shadow var(--transition-base) !important;
}
.ant-input:hover,
.ant-input-affix-wrapper:hover,
.ant-select-selector:hover,
.ant-picker:hover {
  border-color: var(--clr-primary) !important;
}
.ant-input:focus, .ant-input.ant-input-affix-wrapper-focused, .ant-input.ant-select-focused .ant-select-selector,
.ant-input-affix-wrapper:focus,
.ant-input-affix-wrapper.ant-input-affix-wrapper-focused,
.ant-input-affix-wrapper.ant-select-focused .ant-select-selector,
.ant-select-selector:focus,
.ant-select-selector.ant-input-affix-wrapper-focused,
.ant-select-selector.ant-select-focused .ant-select-selector,
.ant-picker:focus,
.ant-picker.ant-input-affix-wrapper-focused,
.ant-picker.ant-select-focused .ant-select-selector {
  border-color: var(--clr-primary) !important;
  box-shadow: 0 0 0 3px var(--clr-primary-light) !important;
}

/* Ant Buttons */
.ant-btn {
  font-family: var(--font-sans) !important;
  font-weight: 500 !important;
  border-radius: var(--radius-md) !important;
  transition: all var(--transition-base) !important;
}

.ant-btn-primary {
  background: linear-gradient(135deg, var(--clr-primary), var(--clr-primary-dark)) !important;
  border: none !important;
  box-shadow: var(--shadow-primary) !important;
}
.ant-btn-primary:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 6px 20px rgba(99, 102, 241, 0.45) !important;
}

/* Ant Modal */
.ant-modal-content {
  border-radius: var(--radius-xl) !important;
  overflow: hidden;
  box-shadow: var(--shadow-lg) !important;
}

.ant-modal-header {
  border-bottom: 1px solid var(--clr-border) !important;
  padding: 16px 24px !important;
}

.ant-modal-title {
  font-weight: 700 !important;
  font-size: 16px !important;
  color: var(--clr-text-primary) !important;
}

/* Ant Select dropdown */
.ant-select-dropdown {
  border-radius: var(--radius-md) !important;
  box-shadow: var(--shadow-lg) !important;
  border: 1px solid var(--clr-border) !important;
}

/* Ant Pagination */
.ant-pagination-item-active {
  border-color: var(--clr-primary) !important;
}
.ant-pagination-item-active a {
  color: var(--clr-primary) !important;
}

/* Ant Badge */
.ant-badge-count {
  background: var(--clr-danger) !important;
  box-shadow: 0 0 0 2px #fff !important;
}

/* Ant Popover */
.ant-popover-inner {
  padding: 8px !important;
  border-radius: var(--radius-lg) !important;
  box-shadow: var(--shadow-lg) !important;
  border: 1px solid var(--clr-border) !important;
}

/* ─── Utility Classes ────────────────────────────────────────── */
.editable-row {
  width: 100% !important;
}

svg {
  cursor: pointer !important;
}

/* Remove number input spinners */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  appearance: textfield;
}

.ant-input-number-handler-wrap {
  display: none !important;
}

.noselect {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}

/* ─── Card Base ──────────────────────────────────────────────── */
.card-base {
  background: var(--clr-surface);
  border-radius: var(--radius-lg);
  border: 1px solid var(--clr-border);
  box-shadow: var(--shadow-sm);
  padding: 20px 24px;
  transition: box-shadow var(--transition-base), transform var(--transition-base);
}
.card-base:hover {
  box-shadow: var(--shadow-md);
}

/* ─── Status Chips ───────────────────────────────────────────── */
.status-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 10px;
  border-radius: 99px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
}
.status-chip--success {
  background: #d1fae5;
  color: #065f46;
}
.status-chip--warning {
  background: #fef3c7;
  color: #92400e;
}
.status-chip--danger {
  background: #fee2e2;
  color: #991b1b;
}
.status-chip--info {
  background: #e0f2fe;
  color: #0c4a6e;
}
.status-chip--default {
  background: #f1f5f9;
  color: #475569;
}

/* ─── Shared CRM Page Header ─────────────────────────────────── */
.crm-page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.crm-page-header .crm-page-title {
  font-size: 22px;
  font-weight: 700;
  color: var(--clr-text-primary);
  margin: 0;
}
.crm-page-header .ant-btn-primary {
  background: linear-gradient(135deg, var(--clr-primary), var(--clr-primary-dark));
  border: none;
  border-radius: 10px;
  font-weight: 600;
  height: 40px;
  padding: 0 20px;
  box-shadow: 0 2px 8px rgba(99, 102, 241, 0.3);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}
.crm-page-header .ant-btn-primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 14px rgba(99, 102, 241, 0.4);
}

/* ─── Shared CRM Table Card ──────────────────────────────────── */
.crm-table-card {
  background: var(--clr-surface);
  border-radius: var(--radius-lg);
  border: 1px solid var(--clr-border);
  box-shadow: var(--shadow-sm);
  overflow: hidden;
  margin-bottom: 16px;
}
.crm-table-card .ant-table {
  background: transparent;
}
.crm-table-card .ant-table-thead > tr > th {
  background: #f8fafc;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--clr-text-secondary);
  border-bottom: 1px solid var(--clr-border);
}
.crm-table-card .ant-table-tbody > tr:hover > td {
  background: #f8f9ff;
}
.crm-table-card .ant-table-tbody > tr > td {
  border-bottom: 1px solid #f1f5f9;
}

/* ─── Shared CRM Modal ───────────────────────────────────────── */
.crm-modal .ant-modal-content {
  border-radius: 16px;
  overflow: hidden;
  padding: 0;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
}
.crm-modal .ant-modal-header {
  padding: 20px 24px 16px;
  border-bottom: 1px solid var(--clr-border);
  background: #fafbff;
  margin-bottom: 0;
}
.crm-modal .ant-modal-body {
  padding: 24px;
}
.crm-modal .ant-modal-close {
  top: 18px;
  right: 20px;
}

.crm-modal-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  font-weight: 700;
  color: var(--clr-text-primary);
}

.crm-modal-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: var(--clr-primary-light);
  color: var(--clr-primary);
  font-size: 16px;
}

.crm-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid var(--clr-border);
}
.crm-modal-footer .ant-btn-primary {
  background: linear-gradient(135deg, var(--clr-primary), var(--clr-primary-dark));
  border: none;
  border-radius: 8px;
  font-weight: 600;
  box-shadow: 0 2px 8px rgba(99, 102, 241, 0.25);
}
.crm-modal-footer .ant-btn-default {
  border-radius: 8px;
  color: var(--clr-text-secondary);
}

/* ─── Global Ant Table Polish ────────────────────────────────── */
.ant-table {
  border-radius: var(--radius-lg) !important;
  overflow: hidden;
}
.ant-table .ant-table-thead > tr > th {
  background: #f8fafc !important;
  font-size: 11px !important;
  font-weight: 700 !important;
  letter-spacing: 0.06em !important;
  text-transform: uppercase !important;
  color: var(--clr-text-secondary) !important;
  border-bottom: 1px solid var(--clr-border) !important;
  padding: 10px 16px !important;
}
.ant-table .ant-table-tbody > tr > td {
  border-bottom: 1px solid #f1f5f9 !important;
  padding: 10px 10px !important;
  font-size: 13.5px;
}
.ant-table .ant-table-tbody > tr:hover > td {
  background: #f8f9ff !important;
}

/* Global Ant Primary Button */
.ant-btn-primary {
  background: linear-gradient(135deg, var(--clr-primary), var(--clr-primary-dark)) !important;
  border: none !important;
  border-radius: var(--radius-md) !important;
  font-weight: 600 !important;
  transition: all var(--transition-base) !important;
}
.ant-btn-primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 14px rgba(99, 102, 241, 0.4) !important;
}

/* ─── Modal Form Field Spacing ───────────────────────────────── */
.crm-modal .ant-form-item {
  margin-bottom: 16px;
}
.crm-modal .ant-form-item .ant-form-item-label > label {
  font-weight: 600;
  font-size: 13px;
  color: var(--clr-text-primary);
}
.crm-modal .ant-form-item .ant-input,
.crm-modal .ant-form-item .ant-input-affix-wrapper,
.crm-modal .ant-form-item .ant-select-selector {
  border-radius: 8px !important;
  border-color: var(--clr-border) !important;
}
.crm-modal .ant-form-item .ant-input:focus,
.crm-modal .ant-form-item .ant-input-affix-wrapper-focused,
.crm-modal .ant-form-item .ant-select-focused .ant-select-selector {
  border-color: var(--clr-primary) !important;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.12) !important;
}

/* ─── Floating Action Button (FAB) ───────────────────────────── */
/* ─── Floating Action Button ─────────────────────────────────── */
.fab-btn {
  position: fixed;
  bottom: 36px;
  right: 36px;
  z-index: 1000;
  width: 58px;
  height: 58px;
  border-radius: 50%;
  border: none;
  outline: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, var(--clr-primary), var(--clr-primary-dark));
  color: #fff;
  font-size: 24px;
  box-shadow: 0 6px 24px rgba(99, 102, 241, 0.5), 0 2px 8px rgba(0, 0, 0, 0.15);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.fab-btn:hover {
  transform: scale(1.1) translateY(-2px);
  box-shadow: 0 10px 32px rgba(99, 102, 241, 0.6), 0 4px 12px rgba(0, 0, 0, 0.18);
}
.fab-btn:active {
  transform: scale(1.02);
}`, "",{"version":3,"sources":["webpack://./src/styles.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAGhB,uEAAA;AACA;EACE,2BAAA;AADF;;AAGA;EACE,8BAAA;EACA,+BAAA;AAAF;;AAEA;EACE,0BAAA;AACF;;AAEA,kEAAA;AACA;EACE,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,qBAAA;EAEA,YAAA;EACA,yBAAA;EACA,4CAAA;EACA,8CAAA;EACA,kCAAA;EACA,gCAAA;EAEA,mBAAA;EACA,sBAAA;EACA,2BAAA;EACA,4CAAA;EACA,qBAAA;EACA,sBAAA;EACA,sBAAA;EACA,qBAAA;EAEA,SAAA;EACA,2BAAA;EACA,6BAAA;EACA,yBAAA;EAEA,YAAA;EACA,0CAAA;EACA,yEAAA;EACA,0EAAA;EACA,0EAAA;EACA,qDAAA;EAEA,eAAA;EACA,sBAAA;EACA,yBAAA;EACA,qBAAA;EAEA,UAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EAEA,gBAAA;EACA,6BAAA;EACA,4BAAA;EACA,oDAAA;EAEA,eAAA;EACA;8EAAA;AANF;;AAUA,mEAAA;AACA;;;EAGE,sBAAA;AAPF;;AAUA;EACE,SAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,8BAAA;EACA,+BAAA;EACA,mCAAA;EACA,kCAAA;AAPF;;AAUA;EACE,+EACE;AARJ;;AAWA,kEAAA;AACA;EACE,kBAAA;AARF;;AAUA,iBAAA;AACA;;EAEE,oCAAA;EACA,2CAAA;EACA,2BAAA;EACA,0BAAA;EACA,oCAAA;EACA,iCAAA;EACA,qDAAA;AAPF;;AAUA;EACE,0CAAA;EACA,gBAAA;EACA,4BAAA;EACA,mCAAA;AAPF;;AAUA;EACE,wCAAA;EACA,0BAAA;AAPF;;AAUA;EACE,8BAAA;AAPF;;AAUA,aAAA;AACA;EACE,2BAAA;EACA,0BAAA;EACA,2CAAA;AAPF;;AAUA;;;;EAIE,0CAAA;EACA,0CAAA;EACA,wCAAA;EACA,0BAAA;EACA,6FACE;AARJ;AAWE;;;;EACE,2CAAA;AANJ;AASE;;;;;;;;;;EAGE,2CAAA;EACA,yDAAA;AAAJ;;AAIA,gBAAA;AACA;EACE,wCAAA;EACA,2BAAA;EACA,0CAAA;EACA,iDAAA;AADF;;AAIA;EACE,2FAAA;EAKA,uBAAA;EACA,4CAAA;AALF;AAOE;EACE,sCAAA;EACA,0DAAA;AALJ;;AASA,cAAA;AACA;EACE,0CAAA;EACA,gBAAA;EACA,uCAAA;AANF;;AASA;EACE,qDAAA;EACA,6BAAA;AANF;;AASA;EACE,2BAAA;EACA,0BAAA;EACA,yCAAA;AANF;;AASA,wBAAA;AACA;EACE,0CAAA;EACA,uCAAA;EACA,8CAAA;AANF;;AASA,mBAAA;AACA;EACE,2CAAA;AANF;AAQE;EACE,oCAAA;AANJ;;AAUA,cAAA;AACA;EACE,wCAAA;EACA,qCAAA;AAPF;;AAUA,gBAAA;AACA;EACE,uBAAA;EACA,0CAAA;EACA,uCAAA;EACA,8CAAA;AAPF;;AAUA,mEAAA;AACA;EACE,sBAAA;AAPF;;AAUA;EACE,0BAAA;AAPF;;AAUA,iCAAA;AACA;;EAEE,wBAAA;EACA,SAAA;AAPF;;AAUA;EAEE,qBAAA;AAPF;;AAUA;EACE,wBAAA;AAPF;;AAUA;EACE,2BAAA;EACA,yBAAA;EAIA,iBAAA;AAPF;;AAUA,mEAAA;AACA;EACE,8BAAA;EACA,+BAAA;EACA,mCAAA;EACA,4BAAA;EACA,kBAAA;EACA,+EACE;AARJ;AAWE;EACE,4BAAA;AATJ;;AAaA,mEAAA;AACA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;AAVF;AAYE;EACE,mBAAA;EACA,cAAA;AAVJ;AAYE;EACE,mBAAA;EACA,cAAA;AAVJ;AAYE;EACE,mBAAA;EACA,cAAA;AAVJ;AAYE;EACE,mBAAA;EACA,cAAA;AAVJ;AAYE;EACE,mBAAA;EACA,cAAA;AAVJ;;AAcA,mEAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AAXF;AAaE;EACE,eAAA;EACA,gBAAA;EACA,8BAAA;EACA,SAAA;AAXJ;AAcE;EACE,gFAAA;EAKA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,6CAAA;EACA,uDACE;AAjBN;AAoBI;EACE,2BAAA;EACA,8CAAA;AAlBN;;AAuBA,mEAAA;AACA;EACE,8BAAA;EACA,+BAAA;EACA,mCAAA;EACA,4BAAA;EACA,gBAAA;EACA,mBAAA;AApBF;AAsBE;EACE,uBAAA;AApBJ;AAsBE;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,gCAAA;EACA,0CAAA;AApBJ;AAsBE;EACE,mBAAA;AApBJ;AAsBE;EACE,gCAAA;AApBJ;;AAwBA,mEAAA;AAEE;EACE,mBAAA;EACA,gBAAA;EACA,UAAA;EACA,2CAAA;AAtBJ;AAwBE;EACE,uBAAA;EACA,0CAAA;EACA,mBAAA;EACA,gBAAA;AAtBJ;AAwBE;EACE,aAAA;AAtBJ;AAwBE;EACE,SAAA;EACA,WAAA;AAtBJ;;AA0BA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,8BAAA;AAvBF;;AA0BA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;EACA,yBAAA;EACA,eAAA;AAvBF;;AA0BA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,uCAAA;AAvBF;AAyBE;EACE,gFAAA;EAKA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;AA3BJ;AA6BE;EACE,kBAAA;EACA,gCAAA;AA3BJ;;AA+BA,mEAAA;AACA;EACE,0CAAA;EACA,gBAAA;AA5BF;AA8BE;EACE,8BAAA;EACA,0BAAA;EACA,2BAAA;EACA,iCAAA;EACA,oCAAA;EACA,2CAAA;EACA,qDAAA;EACA,6BAAA;AA5BJ;AA+BE;EACE,2CAAA;EACA,6BAAA;EACA,iBAAA;AA7BJ;AAgCE;EACE,8BAAA;AA9BJ;;AAkCA,8BAAA;AACA;EACE,2FAAA;EAKA,uBAAA;EACA,0CAAA;EACA,2BAAA;EACA,iDAAA;AAnCF;AAqCE;EACE,2BAAA;EACA,yDAAA;AAnCJ;;AAuCA,mEAAA;AACA;EACE,mBAAA;AApCF;AAsCE;EACE,gBAAA;EACA,eAAA;EACA,8BAAA;AApCJ;AAsCE;;;EAGE,6BAAA;EACA,0CAAA;AApCJ;AAsCE;;;EAGE,2CAAA;EACA,yDAAA;AApCJ;;AAwCA,mEAAA;AACA,mEAAA;AACA;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gFAAA;EAKA,WAAA;EACA,eAAA;EACA,6EACE;EAEF,qDACE;AA5CJ;AA+CE;EACE,sCAAA;EACA,+EACE;AA9CN;AAkDE;EACE,sBAAA;AAhDJ","sourcesContent":["// Bootstrap removed — replaced by minimal utilities below (mt-3, mx-4, p-2 only).\n// Full Bootstrap added ~280 kB to the bundle; Ant Design + our tokens cover the rest.\n\n/* ─── Bootstrap spacing shims (only classes still in legacy code) ── */\n.mt-3 {\n  margin-top: 1rem !important;\n}\n.mx-4 {\n  margin-left: 1.5rem !important;\n  margin-right: 1.5rem !important;\n}\n.p-2 {\n  padding: 0.5rem !important;\n}\n\n/* ─── Design Tokens ─────────────────────────────────────────── */\n:root {\n  /* Palette */\n  --clr-bg: #f1f5f9;\n  --clr-surface: #ffffff;\n  --clr-border: #e2e8f0;\n\n  /* Sidebar */\n  --clr-sidebar-bg: #0f172a;\n  --clr-sidebar-item: rgba(255, 255, 255, 0.6);\n  --clr-sidebar-hover: rgba(255, 255, 255, 0.08);\n  --clr-sidebar-active-from: #6366f1;\n  --clr-sidebar-active-to: #4f46e5;\n\n  /* Brand / Accent */\n  --clr-primary: #6366f1;\n  --clr-primary-dark: #4f46e5;\n  --clr-primary-light: rgba(99, 102, 241, 0.1);\n  --clr-accent: #06b6d4;\n  --clr-success: #10b981;\n  --clr-warning: #f59e0b;\n  --clr-danger: #ef4444;\n\n  /* Text */\n  --clr-text-primary: #0f172a;\n  --clr-text-secondary: #64748b;\n  --clr-text-muted: #94a3b8;\n\n  /* Shadows */\n  --shadow-xs: 0 1px 2px rgba(0, 0, 0, 0.05);\n  --shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.07), 0 1px 2px rgba(0, 0, 0, 0.04);\n  --shadow-md: 0 4px 12px rgba(0, 0, 0, 0.08), 0 2px 4px rgba(0, 0, 0, 0.04);\n  --shadow-lg: 0 10px 30px rgba(0, 0, 0, 0.1), 0 4px 8px rgba(0, 0, 0, 0.04);\n  --shadow-primary: 0 4px 14px rgba(99, 102, 241, 0.35);\n\n  /* Dimensions */\n  --sidebar-width: 256px;\n  --sidebar-collapsed: 72px;\n  --header-height: 64px;\n\n  /* Radii */\n  --radius-sm: 6px;\n  --radius-md: 10px;\n  --radius-lg: 14px;\n  --radius-xl: 20px;\n\n  /* Transitions */\n  --transition-fast: 0.15s ease;\n  --transition-base: 0.2s ease;\n  --transition-slow: 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n\n  /* Typography */\n  --font-sans:\n    \"Inter\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n}\n\n/* ─── Base Reset ─────────────────────────────────────────────── */\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  font-family: var(--font-sans);\n  font-size: 14px;\n  line-height: 1.6;\n  color: var(--clr-text-primary);\n  background-color: var(--clr-bg);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family:\n    source-code-pro, Menlo, Monaco, Consolas, \"Courier New\", monospace;\n}\n\n/* ─── Ant Design Global Overrides ───────────────────────────── */\n.ant-table-content {\n  overflow-y: scroll;\n}\n/* Table header */\n.ant-table-content th,\n.ant-table-thead > tr > th {\n  background-color: #f8fafc !important;\n  color: var(--clr-text-secondary) !important;\n  font-weight: 600 !important;\n  font-size: 12px !important;\n  text-transform: uppercase !important;\n  letter-spacing: 0.05em !important;\n  border-bottom: 1px solid var(--clr-border) !important;\n}\n\n.ant-table-wrapper {\n  border-radius: var(--radius-lg) !important;\n  overflow: hidden;\n  box-shadow: var(--shadow-sm);\n  border: 1px solid var(--clr-border);\n}\n\n.ant-table {\n  font-family: var(--font-sans) !important;\n  font-size: 13px !important;\n}\n\n.ant-table-row:hover > td {\n  background: #f8faff !important;\n}\n\n/* Ant Form */\n.ant-form-item-label > label {\n  font-weight: 500 !important;\n  font-size: 13px !important;\n  color: var(--clr-text-secondary) !important;\n}\n\n.ant-input,\n.ant-input-affix-wrapper,\n.ant-select-selector,\n.ant-picker {\n  border-radius: var(--radius-md) !important;\n  border-color: var(--clr-border) !important;\n  font-family: var(--font-sans) !important;\n  font-size: 14px !important;\n  transition:\n    border-color var(--transition-base),\n    box-shadow var(--transition-base) !important;\n\n  &:hover {\n    border-color: var(--clr-primary) !important;\n  }\n\n  &:focus,\n  &.ant-input-affix-wrapper-focused,\n  &.ant-select-focused .ant-select-selector {\n    border-color: var(--clr-primary) !important;\n    box-shadow: 0 0 0 3px var(--clr-primary-light) !important;\n  }\n}\n\n/* Ant Buttons */\n.ant-btn {\n  font-family: var(--font-sans) !important;\n  font-weight: 500 !important;\n  border-radius: var(--radius-md) !important;\n  transition: all var(--transition-base) !important;\n}\n\n.ant-btn-primary {\n  background: linear-gradient(\n    135deg,\n    var(--clr-primary),\n    var(--clr-primary-dark)\n  ) !important;\n  border: none !important;\n  box-shadow: var(--shadow-primary) !important;\n\n  &:hover {\n    transform: translateY(-1px) !important;\n    box-shadow: 0 6px 20px rgba(99, 102, 241, 0.45) !important;\n  }\n}\n\n/* Ant Modal */\n.ant-modal-content {\n  border-radius: var(--radius-xl) !important;\n  overflow: hidden;\n  box-shadow: var(--shadow-lg) !important;\n}\n\n.ant-modal-header {\n  border-bottom: 1px solid var(--clr-border) !important;\n  padding: 16px 24px !important;\n}\n\n.ant-modal-title {\n  font-weight: 700 !important;\n  font-size: 16px !important;\n  color: var(--clr-text-primary) !important;\n}\n\n/* Ant Select dropdown */\n.ant-select-dropdown {\n  border-radius: var(--radius-md) !important;\n  box-shadow: var(--shadow-lg) !important;\n  border: 1px solid var(--clr-border) !important;\n}\n\n/* Ant Pagination */\n.ant-pagination-item-active {\n  border-color: var(--clr-primary) !important;\n\n  a {\n    color: var(--clr-primary) !important;\n  }\n}\n\n/* Ant Badge */\n.ant-badge-count {\n  background: var(--clr-danger) !important;\n  box-shadow: 0 0 0 2px #fff !important;\n}\n\n/* Ant Popover */\n.ant-popover-inner {\n  padding: 8px !important;\n  border-radius: var(--radius-lg) !important;\n  box-shadow: var(--shadow-lg) !important;\n  border: 1px solid var(--clr-border) !important;\n}\n\n/* ─── Utility Classes ────────────────────────────────────────── */\n.editable-row {\n  width: 100% !important;\n}\n\nsvg {\n  cursor: pointer !important;\n}\n\n/* Remove number input spinners */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\ninput[type=\"number\"] {\n  -moz-appearance: textfield;\n  appearance: textfield;\n}\n\n.ant-input-number-handler-wrap {\n  display: none !important;\n}\n\n.noselect {\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n/* ─── Card Base ──────────────────────────────────────────────── */\n.card-base {\n  background: var(--clr-surface);\n  border-radius: var(--radius-lg);\n  border: 1px solid var(--clr-border);\n  box-shadow: var(--shadow-sm);\n  padding: 20px 24px;\n  transition:\n    box-shadow var(--transition-base),\n    transform var(--transition-base);\n\n  &:hover {\n    box-shadow: var(--shadow-md);\n  }\n}\n\n/* ─── Status Chips ───────────────────────────────────────────── */\n.status-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 3px 10px;\n  border-radius: 99px;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n\n  &--success {\n    background: #d1fae5;\n    color: #065f46;\n  }\n  &--warning {\n    background: #fef3c7;\n    color: #92400e;\n  }\n  &--danger {\n    background: #fee2e2;\n    color: #991b1b;\n  }\n  &--info {\n    background: #e0f2fe;\n    color: #0c4a6e;\n  }\n  &--default {\n    background: #f1f5f9;\n    color: #475569;\n  }\n}\n\n/* ─── Shared CRM Page Header ─────────────────────────────────── */\n.crm-page-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 20px;\n\n  .crm-page-title {\n    font-size: 22px;\n    font-weight: 700;\n    color: var(--clr-text-primary);\n    margin: 0;\n  }\n\n  .ant-btn-primary {\n    background: linear-gradient(\n      135deg,\n      var(--clr-primary),\n      var(--clr-primary-dark)\n    );\n    border: none;\n    border-radius: 10px;\n    font-weight: 600;\n    height: 40px;\n    padding: 0 20px;\n    box-shadow: 0 2px 8px rgba(99, 102, 241, 0.3);\n    transition:\n      transform 0.15s ease,\n      box-shadow 0.15s ease;\n\n    &:hover {\n      transform: translateY(-1px);\n      box-shadow: 0 4px 14px rgba(99, 102, 241, 0.4);\n    }\n  }\n}\n\n/* ─── Shared CRM Table Card ──────────────────────────────────── */\n.crm-table-card {\n  background: var(--clr-surface);\n  border-radius: var(--radius-lg);\n  border: 1px solid var(--clr-border);\n  box-shadow: var(--shadow-sm);\n  overflow: hidden;\n  margin-bottom: 16px;\n\n  .ant-table {\n    background: transparent;\n  }\n  .ant-table-thead > tr > th {\n    background: #f8fafc;\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    color: var(--clr-text-secondary);\n    border-bottom: 1px solid var(--clr-border);\n  }\n  .ant-table-tbody > tr:hover > td {\n    background: #f8f9ff;\n  }\n  .ant-table-tbody > tr > td {\n    border-bottom: 1px solid #f1f5f9;\n  }\n}\n\n/* ─── Shared CRM Modal ───────────────────────────────────────── */\n.crm-modal {\n  .ant-modal-content {\n    border-radius: 16px;\n    overflow: hidden;\n    padding: 0;\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);\n  }\n  .ant-modal-header {\n    padding: 20px 24px 16px;\n    border-bottom: 1px solid var(--clr-border);\n    background: #fafbff;\n    margin-bottom: 0;\n  }\n  .ant-modal-body {\n    padding: 24px;\n  }\n  .ant-modal-close {\n    top: 18px;\n    right: 20px;\n  }\n}\n\n.crm-modal-title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 16px;\n  font-weight: 700;\n  color: var(--clr-text-primary);\n}\n\n.crm-modal-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  background: var(--clr-primary-light);\n  color: var(--clr-primary);\n  font-size: 16px;\n}\n\n.crm-modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 24px;\n  padding-top: 16px;\n  border-top: 1px solid var(--clr-border);\n\n  .ant-btn-primary {\n    background: linear-gradient(\n      135deg,\n      var(--clr-primary),\n      var(--clr-primary-dark)\n    );\n    border: none;\n    border-radius: 8px;\n    font-weight: 600;\n    box-shadow: 0 2px 8px rgba(99, 102, 241, 0.25);\n  }\n  .ant-btn-default {\n    border-radius: 8px;\n    color: var(--clr-text-secondary);\n  }\n}\n\n/* ─── Global Ant Table Polish ────────────────────────────────── */\n.ant-table {\n  border-radius: var(--radius-lg) !important;\n  overflow: hidden;\n\n  .ant-table-thead > tr > th {\n    background: #f8fafc !important;\n    font-size: 11px !important;\n    font-weight: 700 !important;\n    letter-spacing: 0.06em !important;\n    text-transform: uppercase !important;\n    color: var(--clr-text-secondary) !important;\n    border-bottom: 1px solid var(--clr-border) !important;\n    padding: 10px 16px !important;\n  }\n\n  .ant-table-tbody > tr > td {\n    border-bottom: 1px solid #f1f5f9 !important;\n    padding: 10px 10px !important;\n    font-size: 13.5px;\n  }\n\n  .ant-table-tbody > tr:hover > td {\n    background: #f8f9ff !important;\n  }\n}\n\n/* Global Ant Primary Button */\n.ant-btn-primary {\n  background: linear-gradient(\n    135deg,\n    var(--clr-primary),\n    var(--clr-primary-dark)\n  ) !important;\n  border: none !important;\n  border-radius: var(--radius-md) !important;\n  font-weight: 600 !important;\n  transition: all var(--transition-base) !important;\n\n  &:hover {\n    transform: translateY(-1px);\n    box-shadow: 0 4px 14px rgba(99, 102, 241, 0.4) !important;\n  }\n}\n\n/* ─── Modal Form Field Spacing ───────────────────────────────── */\n.crm-modal .ant-form-item {\n  margin-bottom: 16px;\n\n  .ant-form-item-label > label {\n    font-weight: 600;\n    font-size: 13px;\n    color: var(--clr-text-primary);\n  }\n  .ant-input,\n  .ant-input-affix-wrapper,\n  .ant-select-selector {\n    border-radius: 8px !important;\n    border-color: var(--clr-border) !important;\n  }\n  .ant-input:focus,\n  .ant-input-affix-wrapper-focused,\n  .ant-select-focused .ant-select-selector {\n    border-color: var(--clr-primary) !important;\n    box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.12) !important;\n  }\n}\n\n/* ─── Floating Action Button (FAB) ───────────────────────────── */\n/* ─── Floating Action Button ─────────────────────────────────── */\n.fab-btn {\n  position: fixed;\n  bottom: 36px;\n  right: 36px;\n  z-index: 1000;\n  width: 58px;\n  height: 58px;\n  border-radius: 50%;\n  border: none;\n  outline: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(\n    135deg,\n    var(--clr-primary),\n    var(--clr-primary-dark)\n  );\n  color: #fff;\n  font-size: 24px;\n  box-shadow:\n    0 6px 24px rgba(99, 102, 241, 0.5),\n    0 2px 8px rgba(0, 0, 0, 0.15);\n  transition:\n    transform 0.2s ease,\n    box-shadow 0.2s ease;\n\n  &:hover {\n    transform: scale(1.1) translateY(-2px);\n    box-shadow:\n      0 10px 32px rgba(99, 102, 241, 0.6),\n      0 4px 12px rgba(0, 0, 0, 0.18);\n  }\n\n  &:active {\n    transform: scale(1.02);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
